export default {
  data() {
    return {
      timesheetRedirectUrl: null,
      previousValidationToken: null,
      previousRequestTimeEntryId: null,
      redirectTimeoutId: null,
    };
  },
  methods: {
    redirectToTimesheet() {
      const theWindow = window;
      const redirectUrl = new URL(this.timesheetRedirectUrl, theWindow.location.origin);
      const currentUrl = theWindow.location;

      if (redirectUrl.pathname !== currentUrl.pathname) {
        this.$appMessage('The timesheet has been reopened. You will be redirected to review it.');
      }

      this.redirectTimeoutId = setTimeout(() => {
        theWindow.location.href = this.timesheetRedirectUrl;
        this.timesheetRedirectUrl = null;
      }, 2000);
    },
    handleOverrideCancel() {
      this.timesheetRedirectUrl = null;
      if (this.previousValidationToken) {
        this.validationToken = this.previousValidationToken;
        this.previousValidationToken = null;
      }
      if (this.previousRequestTimeEntryId) {
        this.requestTimeEntryId = this.previousRequestTimeEntryId;
        this.previousRequestTimeEntryId = null;
      }
    },
    async handleSuccessfulAction() {
      if (this.timesheetRedirectUrl) {
        this.redirectToTimesheet();
      } else {
        this.close();
        await this.$store.dispatch('loadData');
      }
    },
  },
  beforeUnmount() {
    if (this.redirectTimeoutId) {
      clearTimeout(this.redirectTimeoutId);
      this.redirectTimeoutId = null;
    }
  },
};
